import * as React from "react";
const SvgFiRrTugrikSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tugrik-sign_svg__a)">
      <path
        fill="#062147"
        d="M22 1c0 .55-.45 1-1 1h-8v7.08l5.66-2.02a.995.995 0 0 1 1.28.61.995.995 0 0 1-.61 1.28l-6.34 2.26v1.88l5.66-2.02c.52-.19 1.09.09 1.28.61a.995.995 0 0 1-.61 1.28l-6.34 2.26v7.8c0 .55-.45 1-1 1s-1-.45-1-1v-7.08l-5.66 2.02c-.11.04-.22.06-.34.06-.41 0-.8-.25-.94-.66a.995.995 0 0 1 .61-1.28l6.34-2.26v-1.88l-5.66 2.02c-.11.04-.22.06-.34.06-.41 0-.8-.25-.94-.66a.995.995 0 0 1 .61-1.28L11 9.82V2H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tugrik-sign_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTugrikSign;
